/**
 * 新疆舆情显示设置
 * by 于再洋
 * 2017-12-24
 */
"use strict";
angular.module("displaySettingModule", [
    // "functionListServiceMoudle" //服务
]).
controller("displaySettingCtrl", ["$scope", "$filter", "trsHttpService","$timeout","modalDialog", function($scope, $filter, trsHttpService,$timeout,modalDialog) {
    initStatus();
    initData();
    /**
     * [shareLink description] 分享链接
     * @return {[type]} [description]
     */
    // $scope.shareLink = function(){
    // 	functionListService.shareLink();
    // };
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            setting: true,//编辑显示
            saveright:false,//保存提示
            saveerr:false,//错误提示
            change:false,//编辑之后有改变
            savetext:"",//保存提示文本
        };
        $scope.data = {
            areaData:true,
            areadata:[],//最新话题数据
            brareaData:true,
            newsdata:[],//突发新闻数据
            newsfieldData:true,
            newsfield:[],//突发新闻标签
            selectId:[],
            resetId:"",
        };
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        requestBrData();
        requestNewData();
        // requestFieldData();
        requestIdData();
    }
    /**
     * [requestBrData description] 请求突发新闻数据
     */
    function requestBrData() {
        var params = {
            "typeid": 'screen',
            "serviceid": 'zjsentimentshow',
            "modelid": 'getdatainitconfig',
            "section": 2,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            //$scope.hotFeatureList = JSON.parse(data.mapResult.content);
            var tabList = [];
            var newareadata = [];
            for (var i = 0; i < data.length; i ++) {
                tabList.push(data[i]);
                newareadata.push(data[i].id);
            }
            $scope.data.newsdata = newareadata;
            $scope.settingBrList = angular.copy(tabList);
            for(var i=0;i<$scope.settingBrList.length;i++ ){
                $scope.settingBrList[i].select=true;
            }
        });
    }
    /**
     * [requestNewData description] 请求最新话题数据
     */
    function requestNewData() {
        var params = {
            "typeid": 'screen',
            "serviceid": 'zjsentimentshow',
            "modelid": 'getdatainitconfig',
            "section": 1,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            //$scope.hotFeatureList = JSON.parse(data.mapResult.content);
            var tabList = [];
            var brareadata = [];
            for (var i = 0; i < data.length; i ++) {
                tabList.push(data[i]);
                brareadata.push(data[i].id);
            }
            $scope.data.areadata = brareadata;
            $scope.settingNewList = angular.copy(tabList);
            for(var i=0;i<$scope.settingNewList.length;i++ ){
                $scope.settingNewList[i].select=true;
            }
        });
    }
    /**
     * [requestFieldData description] 请求领域设置数据
     */
    function requestFieldData() {
        var params = {
            "typeid": 'screen',
            "serviceid": 'zjsentimentshow',
            "modelid": 'getfieldinitconfig',
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            //$scope.hotFeatureList = JSON.parse(data.mapResult.content);
            var tabList = [];
            var fielddata = [];
            for (var i = 0; i < data.length; i ++) {
                tabList.push(data[i]);
                fielddata.push(data[i].id);
            }
            $scope.data.newsfield = fielddata;
            $scope.settingFieldList = angular.copy(tabList);
            for(var i=0;i<$scope.settingFieldList.length;i++ ){
                $scope.settingFieldList[i].select=true;
            }
        });
    }
    /**
     * [requestIdData description] 勾选的设置数据
     */
    function requestIdData() {
        var params = {
            "typeid": 'screen',
            "serviceid": 'zjsentimentshow',
            "modelid": 'getselectconfig',
            "id": angular.isDefined(localStorage.getItem('saveId')) ? localStorage.getItem('saveId') : '',
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            //重置最新话题勾选
            var tabidList = data[0];
            var tabidnum = [];
            for(var c in tabidList){
                tabidnum.push(tabidList[c]);
            }
            $scope.settingNewIdList = angular.copy(tabidList);
            if($scope.settingNewList.length == tabidnum.length){
                $scope.data.areaData=true;
                var newareadata =[];
                for(var i=0;i<$scope.settingNewList.length;i++ ){
                    $scope.settingNewList[i].select=true;
                    newareadata.push($scope.settingNewList[i].id.toString());
                }
                $scope.data.areadata = newareadata;
            }else{
                $scope.data.areaData=false;
                $scope.data.areadata=[];
                for(var i=0;i<$scope.settingNewList.length;i++ ){
                    $scope.settingNewList[i].select=false;
                    for(var e in $scope.settingNewIdList){
                        if($scope.settingNewList[i].id == e){
                            $scope.settingNewList[i].select=true;
                            $scope.data.areadata.push(e);
                        }
                    }
                }
            }


            //重置突发新闻勾选

            var tabbridList = data[1];
            var tabbridnum = [];
            for(var c in tabbridList){
                tabbridnum.push(tabbridList[c]);
            }
            //console.log(tabbridList);
            $scope.settingBrIdList = angular.copy(tabbridList);
            if($scope.settingBrList.length == tabbridnum.length){
                $scope.data.brareaData = true;
                var brareadata =[];
                for(var i=0;i<$scope.settingBrList.length;i++ ){
                    $scope.settingBrList[i].select=true;
                    brareadata.push($scope.settingBrList[i].id.toString());
                }
                $scope.data.newsdata = brareadata;
            }else{
                $scope.data.brareaData = false;
                $scope.data.newsdata=[];
                for(var i=0;i<$scope.settingBrList.length;i++ ){
                    $scope.settingBrList[i].select=false;
                    for(var e in $scope.settingBrIdList){
                        if($scope.settingBrList[i].id == e){
                            $scope.settingBrList[i].select=true;
                            $scope.data.newsdata.push(e);
                        }
                    }
                }
            }


            //重置突发新闻领域勾选

            var tabfiidList = data[2];
            //console.log(tabbridList);
            var tabfiidnum = [];
            for(var c in tabfiidList){
                tabfiidnum.push(tabfiidList[c]);
            }
            $scope.settingFiIdList = angular.copy(tabfiidList);
            if($scope.settingFieldList.length == tabfiidnum.length){
                $scope.data.newsfieldData = true;
                var fielddata =[];
                for(var i=0;i<$scope.settingFieldList.length;i++ ){
                    $scope.settingFieldList[i].select=true;
                    fielddata.push($scope.settingFieldList[i].id);
                }
                $scope.data.newsfield = fielddata;
            }else{
                $scope.data.newsfieldData = false;
                $scope.data.newsfield=[];
                for(var i=0;i<$scope.settingFieldList.length;i++ ){
                    $scope.settingFieldList[i].select=false;
                    for(var e in $scope.settingFiIdList){
                        if($scope.settingFieldList[i].id == e){
                            $scope.settingFieldList[i].select=true;
                            $scope.data.newsfield.push(e);
                        }
                    }
                }
            }


        });
    }
    /**
     * [setting description] 编辑按钮
     * @return {[type]} [description]
     */
    $scope.setting= function() {
        $scope.status.setting = false;
    }
    /**
     * [cancelset description] 取消编辑按钮
     * @return {[type]} [description]
     */
    $scope.cancelset= function() {
        $scope.status.setting = true;
    }
    /**
     * [selectNewAll description] 最新话题全选按钮
     * @return {[type]} [description]
     */
    $scope.selectNewAll = function(list) {
        $scope.status.change = true;
        $scope.data.areadata = [];
        $scope.data.areaData = !$scope.data.areaData;
        if($scope.data.areaData){
            var newareadata =[];
            for(var i=0;i<$scope.settingNewList.length;i++ ){
                $scope.settingNewList[i].select=true;
                newareadata.push($scope.settingNewList[i].id.toString());
            }
            $scope.data.areadata = newareadata;
        }else{
            $scope.data.areadata = [];
            for(var i=0;i<$scope.settingNewList.length;i++ ){
                $scope.settingNewList[i].select=false;
            }
        }
    };
    /**
     * [selectNew description] 最新话题单选按钮
     * @return {[type]} [description]
     */
    $scope.selectNew = function(list) {
        $scope.status.change = true;
        list.select=!list.select;
        if(list.select){
            $scope.data.areadata.push(list.id.toString());
        }else{
            var index=$scope.data.areadata.indexOf(list.id.toString());
            $scope.data.areadata.splice(index,1);
        }
        if($scope.data.areadata.length==$scope.settingNewList.length){
            $scope.data.areaData=true;
        }else{
            $scope.data.areaData=false;
        }
    };
    /**
     * [selectBrAll description] 突发新闻全选按钮
     * @return {[type]} [description]
     */
    $scope.selectBrAll = function(list) {
        $scope.status.change = true;
        $scope.data.newsdata = [];
        $scope.data.brareaData = !$scope.data.brareaData;
        if($scope.data.brareaData){
            var brareadata =[];
            for(var i=0;i<$scope.settingBrList.length;i++ ){
                $scope.settingBrList[i].select=true;
                brareadata.push($scope.settingBrList[i].id.toString());
            }
            $scope.data.newsdata = brareadata;
        }else{
            $scope.data.newsdata = [];
            for(var i=0;i<$scope.settingBrList.length;i++ ){
                $scope.settingBrList[i].select=false;
            }
        }
    };
    /**
     * [selectBr description] 突发新闻单选按钮
     * @return {[type]} [description]
     */
    $scope.selectBr = function(list) {
        $scope.status.change = true;
        list.select=!list.select;
        if(list.select){
            $scope.data.newsdata.push(list.id.toString());
        }else{
            var index=$scope.data.newsdata.indexOf(list.id.toString());
            $scope.data.newsdata.splice(index,1);
        }
        if($scope.data.newsdata.length==$scope.settingBrList.length){
            $scope.data.brareaData=true;
        }else{
            $scope.data.brareaData=false;
        }
    };
    /**
     * [selectFiAll description] 突发新闻领域全选按钮
     * @return {[type]} [description]
     */
    $scope.selectFiAll = function(list) {
        $scope.status.change = true;
        $scope.data.newsfield = [];
        $scope.data.newsfieldData = !$scope.data.newsfieldData;
        if($scope.data.newsfieldData){
            var fielddata =[];
            for(var i=0;i<$scope.settingFieldList.length;i++ ){
                $scope.settingFieldList[i].select=true;
                fielddata.push($scope.settingFieldList[i].id.toString());
            }
            $scope.data.newsfield = fielddata;
        }else{
            $scope.data.newsfield = [];
            for(var i=0;i<$scope.settingFieldList.length;i++ ){
                $scope.settingFieldList[i].select=false;
            }
        }
    };
    /**
     * [selectFi description] 突发新闻领域单选按钮
     * @return {[type]} [description]
     */
    $scope.selectFi = function(list) {
        $scope.status.change = true;
        list.select=!list.select;
        if(list.select){
            $scope.data.newsfield.push(list.id.toString());
        }else{
            var index=$scope.data.newsfield.indexOf(list.id.toString());
            $scope.data.newsfield.splice(index,1);
        }
        if($scope.data.newsfield.length==$scope.settingFieldList.length){
            $scope.data.newsfieldData=true;
        }else{
            $scope.data.newsfieldData=false;
        }
    };
    /**
     * [dissave description] 保存按钮
     * @return {[type]} [description]
     */
    $scope.dissave = function() {
        if( $scope.status.change == false){
            $scope.status.setting = true;
        }else if($scope.data.areadata == "" || $scope.data.newsdata == ""){
            modalDialog.alertType("每项设置至少选一项！", "", "info", "confirm", function() {});
            return;
        }else{
            var params = {
                "typeid": 'screen',
                "serviceid": 'zjsentimentshow',
                "modelid": 'saveselectconfig',
                "areadata":$scope.data.areadata.join(","),
                "newsdata":$scope.data.newsdata.join(","),
                // "newsfield":$scope.data.newsfield.join(","),
                "id":'1',
            };
            // if($scope.data.resetId == 1){
            //     params.id=$scope.data.resetId
            // }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                if(data){
                    localStorage.setItem('saveId',data.trim());
                    $scope.data.resetId == data;
                    modalDialog.alertType("保存成功", "", "success", false, function() {
                        initData();
                        $scope.status.setting = true;
                    });
                } else {
                    modalDialog.alertType( '失败',"", "error", false, function() {
                        return;
                    });
                }
            });

        }

    }

}]);
